module.exports = __webpack_public_path__ + "img/GP3 p1.90279097.png";